import {
  getResource,
  getStudentResource,
  shareResource,
  getShareableLink,
  getRecommendedResources,
  getAssociatedResources,
  getRedirectedResource,
  requestResourceInformation
} from '../../services/ResourceService'
import { putUserResourceFolders } from '../../services/FolderService'
import { isError, isRedirection } from '../../utils/api'
import router, { routes } from '../../router'

export default {
  state: {
    redirectedResource: false,
    resource: {},
    shareToken: '',
    recommendedResources: {
      page: 0,
      resources: [],
      totalPages: 0
    },
    associatedResources: {
      page: 0,
      resources: [],
      totalPages: 0
    }
  },

  mutations: {
    setResource(state, resource) {
      state.resource = resource
    },
    setShareToken(state, token) {
      state.shareToken = token
    },
    setRecommendedResourcesForResource(state, status) {
      state.recommendedResources.resources = [...state.recommendedResources.resources, ...status.data]
      state.recommendedResources.page += Math.ceil(status.data.length / 4)
      state.recommendedResources.totalPages = status.pages
    },
    setAssociatedResourcesForResource(state, status) {
      state.associatedResources.resources = [...state.associatedResources.resources, ...status.data]
      state.associatedResources.page += Math.ceil(status.data.length / 4)
      state.associatedResources.totalPages = status.pages
    },
    clearAssociatedResources(state) {
      state.associatedResources = {
        page: 0,
        resources: [],
        totalPages: 0
      }
    },
    setRedirectedResource(state, status) {
      state.redirectedResource = status
    },
    clearRedirectedResource(state) {
      state.redirectedResource = false
    }
  },

  actions: {
    async hydrateResource({ commit }, payload) {
      commit('clearRedirectedResource')
      const { id, locale } = payload
      commit('show', { element: 'fullPageLoader' })
      const response = await getResource(id, locale).catch(e => e.response)
      if (isError(response.status)) router.push({ name: routes.notFound })
      else if (isRedirection(response.status)) {
        const redirectedResponse = await getRedirectedResource(response.data.value).catch(e => e.response)
        commit('setResource', redirectedResponse.data)
        commit('setRedirectedResource', true)
      } else {
        commit('setResource', response.data)
      }
      commit('hide', { element: 'fullPageLoader' })
    },
    async addToFolders({ commit }, { ownedFolders, sharedFolders, resource, locale }) {
      await putUserResourceFolders({
        resourceId: resource,
        owned: ownedFolders,
        shared: sharedFolders,
        locale
      })
    },
    async hydrateStudentResource({ commit, dispatch }, payload) {
      const { token } = payload
      commit('show', { element: 'fullPageLoader' })
      const response = await getStudentResource(token).catch(e => e.response)
      if (!isError(response.status)) {
        commit('setResource', response.data)
        dispatch('changeInnerLocale', response.data.locale || 'ES_AR')
      }
      commit('hide', { element: 'fullPageLoader' })
    },
    async getShareableLink({ commit }, payload) {
      const response = await getShareableLink(payload)
      commit('setShareToken', response.data)
    },
    async shareResource({ commit }, payload) {
      const { resourceLink, recipientIds, resourceName, successMessage, locale, resourceLocale, resourceId } = payload
      commit('show', { element: 'fullPageLoader' })
      commit('hide', { element: 'shareResourceModal' })
      await shareResource({ resourceLink, recipientIds, resourceName, resourceId, locale, resourceLocale })
      commit('hide', { element: 'shareResourceModal' })
      commit('hide', { element: 'fullPageLoader' })
      commit('show', {
        element: 'doneModal',
        props: {
          message: successMessage,
          background: 'share-resource'
        }
      })
    },
    async getRecommendedResourcesForResource({ commit }, payload) {
      const { pageNumber } = payload
      const response = await getRecommendedResources(pageNumber).catch(e => e.response)
      if (!isError(response.status)) commit('setRecommendedResourcesForResource', response.data)
    },
    async getAssociatedResourcesForResource({ commit }, payload) {
      const { pageNumber, id } = payload
      const response = await getAssociatedResources(id, pageNumber).catch(e => e.response)
      if (!isError(response.status)) commit('setAssociatedResourcesForResource', response.data)
    },
    async requestResourceInformation({ commit }, payload) {
      const response = await requestResourceInformation(payload).catch(e => e.response)
      const success = !isError(response.status)
      return { success, data: response.data }
    }
  },

  getters: {
    resourceId: state => state.resource.id
  }
}
